import application from 'application/application';

import template from './movements.template.html';

import submenuTemplate from './inner/submenu/submenu.template.html';

import controller from './movements.controller';

import submenuController from './inner/submenu/submenu.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.movements', {
				abstract: true,
				views: {
					'submenu@root.default': {
						templateUrl: submenuTemplate,
						controller: submenuController
					},
					'default@root.default': {
						templateUrl: template,
						controller: controller
					}
				},
				data: {
					documentTitle: 'Movimentações'
				}
			});

	}]);
